import { Gauge } from 'gauge-chart-js';
import gradstop from 'gradstop';

class Gauges {
  constructor() {
    this.init();
  }

  init() {
    const gaugeFills = Array.from(document.querySelectorAll('.js-gauge-fill'));
    const gaugeBgs = Array.from(document.querySelectorAll('.js-gauge-bg'));
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (gaugeBgs.length > 0) {
      gaugeBgs.forEach(bg => {
        const fromAngle = 270;
        const toAngle = 450;

        const gauge = new Gauge({
          animationDuration: 0,
          container: bg,
          fromAngle: fromAngle,
          toAngle: toAngle,
          lineWidth: 2.25,
          color: 'currentColor',
        });

        gauge.setValue(180);
      });
    }

    if (gaugeFills.length > 0) {
      gaugeFills.forEach(fill => {
        const fromAngle = 270;
        const toAngle = 450;
        const maxValue = toAngle - fromAngle;

        const mutationObserver = new MutationObserver(inViewCallback);
        mutationObserver.observe(fill, { attributeFilter: ['class'] });

        const gauge = new Gauge({
          animationDuration: reduceMotion ? 0 : 400,
          container: fill,
          fromAngle: fromAngle,
          toAngle: toAngle,
          lineWidth: 2.25,
          colors: gradstop({
            stops: maxValue,
            colorArray: ['#3c1053', '#e10a0a', '#e10a0a', '#e10a0a'],
          }),
        });

        // Trigger the gauge animation when in view.
        function inViewCallback(mutationsList) {
          mutationsList.forEach(mutation => {
            if (mutation.target.classList.contains('is-in-view')) {
              gauge.setValue((fill.dataset.percent / 100) * 180);
              mutationObserver.disconnect();
            }
          });
        }
      });
    }
  }
}

export default Gauges;
